import { useEffect, useState } from "react";
import { IAdjustmentDetails, ITransaction } from "../../interface/ITransactionHistory";
import { getAdjustmentDetailsRoute } from "@api-routes/adjustments";
import { useFetch } from "@common/hook/useFetch";

export const useGetAdjustmentDetails = (reference: ITransaction["reference"]) => {
    const [adjustmentDetails, setAdjustmentDetails] = useState<IAdjustmentDetails>();
    const [getAdjustmentDetailsState, { get }] = useFetch();

    useEffect(() => {
        get<IAdjustmentDetails>(getAdjustmentDetailsRoute(reference)).then(setAdjustmentDetails);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reference]);

    return { adjustmentDetails, getAdjustmentDetailsState };
};
